import { PrimaryButton, SecondaryButton, TickIcon, Typography } from '@weareopenr/component-library';
import { pluralize } from '../../helpers/pluralize/pluralize';
import classes from 'classnames/bind';
import styles from './PricingSaveSummary.module.scss';
import { FieldValues, UseFormReset } from 'react-hook-form';
import { PRICING_FORM_ID } from 'src/constants';

const cx = classes.bind(styles);

export const PricingSaveSummary = <TFieldValues extends FieldValues>({
  isSubmitting,
  reset,
  totalChanges,
  form = PRICING_FORM_ID,
}: {
  isSubmitting: boolean;
  reset: UseFormReset<TFieldValues>;
  totalChanges: number;
  form?: string;
}) => {
  return (
    <div className={styles['save-container']}>
      <SecondaryButton
        colour="tomato"
        buttonStyle="ghost"
        className={cx('reset-button')}
        onClick={() => {
          reset();
        }}
      >
        Reset Changes
      </SecondaryButton>
      <div className={styles['right-container']}>
        <Typography
          className={styles['total-changes']}
          weight="semi-bold"
        >{`${totalChanges} price ${pluralize('change', totalChanges)}`}</Typography>

        <PrimaryButton type="submit" form={form} icon={TickIcon} loading={isSubmitting}>
          {`Save ${pluralize('change', totalChanges)}`}
        </PrimaryButton>
      </div>
    </div>
  );
};
